import { createSelector } from "@reduxjs/toolkit";

export const DashboardSelector = createSelector(
    (state: any) => state.profiles,
    (profiles) => profiles
);